import { render } from "./functionCallingWithObjectComponent.vue?vue&type=template&id=87a970ca&scoped=true"
import script from "./functionCallingWithObjectComponent.vue?vue&type=script&lang=js"
export * from "./functionCallingWithObjectComponent.vue?vue&type=script&lang=js"

import "./functionCallingWithObjectComponent.vue?vue&type=style&index=0&id=87a970ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a970ca"]])

export default __exports__